import React, { useState } from 'react'
import { Display } from '../Main/styles';
import EmployeeFilter from './EmployeeFilter';
import EmployeeTable from './EmployeeTable';
import dayjs from 'dayjs';
import { RangePickerProps } from 'rc-picker/es/RangePicker.d';
import { useEmployeeList } from 'CRM/hooks/GetEmployeeList';
import {useIsMobile} from "../../components/IsMobile";
import {ReactComponent as FilterArrowBottom} from "../../../assets/FilterArrowBottom.svg";
import styled from "styled-components";

export const Employee = () => {
  const IsMobile = useIsMobile();
  const [branch, setBranch] = useState(1);
  const [team, setTeam] = useState(null);
  const [createdAt, setCreatedAt] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [updatedAt, setUpdatedAt] = useState<RangePickerProps<dayjs.Dayjs>['value'] | any>([null, null]);
  const [word, setWord] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [isFilter, setIsFilter] = useState(false);

  const { employeeList, total, mutate } =
  useEmployeeList(
    branch == null ? '' : branch, 
    team == null ? '' : team, 
    createdAt?.[0] == null ? '' : (`${dayjs(createdAt?.[0])?.format('YYYY-MM-DD')}~${dayjs(createdAt?.[1])?.format('YYYY-MM-DD')}`), 
    updatedAt?.[0] == null ? '' : (`${dayjs(updatedAt?.[0])?.format('YYYY-MM-DD')}~${dayjs(updatedAt?.[1])?.format('YYYY-MM-DD')}`), 
    word, page, pageSize
    )
  
  return (
    <Display IsMobile={IsMobile}>

      {IsMobile &&
        <div style={{
          backgroundColor: 'white',
          width: '100%',
          height: 40,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          zIndex: 2,
          boxShadow: '2px 2px 8px 2px #74747476',
          cursor: 'pointer',
          marginBottom: !isFilter ? 20 : 0
        }} onClick={() => setIsFilter(!isFilter)}>
          <div style={{marginLeft: 15}}>필터</div>
          {isFilter ?
            <RotatedSvg style={{width: 45, height: 25}}/>
            :
            <FilterArrowBottom style={{width: 45, height: 25}}/>
          }
        </div>
      }

      {IsMobile ?
        <>
          {isFilter &&
            <EmployeeFilter
              branch={branch}
              setBranch={setBranch}
              team={team}
              setTeam={setTeam}
              createdAt={createdAt}
              setCreatedAt={setCreatedAt}
              updatedAt={updatedAt}
              setUpdatedAt={setUpdatedAt}
              word={word}
              setWord={setWord}
            />
          }
        </>
        :
        <EmployeeFilter
          branch={branch}
          setBranch={setBranch}
          team={team}
          setTeam={setTeam}
          createdAt={createdAt}
          setCreatedAt={setCreatedAt}
          updatedAt={updatedAt}
          setUpdatedAt={setUpdatedAt}
          word={word}
          setWord={setWord}
        />
      }

      <EmployeeTable
        employeeList={employeeList}
        mutate={mutate}
        total={total}
        page={page}
        pageSize={pageSize}
        setPage={setPage}
        setPageSize={setPageSize}
      />
    </Display>
  )
}

export default React.memo(Employee);

const RotatedSvg = styled(FilterArrowBottom)`
  transform: rotate(180deg);
  width: 45px;
  height: 25px;
`;